import { ValueOf } from "src/types.d"

export const ContactScheduleAnswerScreens = Object.freeze({
  ContactScheduleAnswerOverview: "ContactScheduleAnswerOverview",
  ContactScheduleAnswerDetail: "ContactScheduleAnswerDetail",
} as const)

export type ContactScheduleAnswerScreens = ValueOf<typeof ContactScheduleAnswerScreens>
